import { render, staticRenderFns } from "./affiliationCard.vue?vue&type=template&id=0eb23607&scoped=true"
import script from "./affiliationCard.vue?vue&type=script&lang=js"
export * from "./affiliationCard.vue?vue&type=script&lang=js"
import style0 from "./affiliationCard.vue?vue&type=style&index=0&id=0eb23607&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb23607",
  null
  
)

export default component.exports